import { render, staticRenderFns } from "./SettingUserDetail.vue?vue&type=template&id=c47ebc36&scoped=true&"
import script from "./SettingUserDetail.vue?vue&type=script&lang=js&"
export * from "./SettingUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingUserDetail.vue?vue&type=style&index=0&id=c47ebc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ebc36",
  null
  
)

export default component.exports